const support = {
  header: 'Administrador',
  howCreateUser: '¿Cómo puedo crear un nuevo usuario?',
  explainHowCreateaUser:
    'Para crear un nuevo usuario, inicie sesión en el administrador web, haga clic en la pestaña "Usuarios" en el menú del lado izquierdo, haga clic en "Nuevo usuario", introduzca sus datos y haga clic en "Añadir" en la parte inferior.',

  howCreateaJob: '¿Cómo se hacen las reservas?',
  explainHowCreateaJob:
    'Para realizar una reserva, seleccione & apos;	reservas y apos;	 en el menú principal y luego haga clic en & apos;	Nueva reserva & apos;	. Introduzca la información correspondiente y haga clic en Reservar.',

  howCreateaJobManual: '¿Cómo enruto las reservas manualmente?',
  explainHowCreateaJobManual:
    'En el menú de la izquierda, presione en reservas. Para enrutar las reservas deseadas en viajes compartidos optimizados, seleccione las reservas haciendo clic en el cuadro pequeño a la izquierda de las reservas que desea optimizar (<b> O </b> el cuadro a la izquierda de la página Todos / Todos los resultados) y luego presione en la ruta',

  howMakeReports: '¿Cómo veo los informes?',
  explainMakeReports: 'Los informes avanzados se pueden encontrar en "Informes" pestaña en el portal.',

  whereGuide: '¿Dónde puedo encontrar una guía de usuario?',
  explaneWhereGuideStart: 'Si necesita ayuda para comenzar, puede revisar nuestro',
  explaneWhereGuideEnd: 'guía del usuario de administrador',

  infoHeader: '¿Qué pasa si necesito hablar con alguien?',
  infoBody1: 'Puede encontrarnos en el teléfono:',
  infoBody2: 'o por correo electrónico:',
  infoBody3: 'Nuestro equipo de servicio al cliente está disponible las 24 horas del día, los 7 días de la semana para responder a cualquier pregunta',
};

export default support;
